import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { ApiError } from '../models/api-error';

@Injectable()
export class ErrorNotificationService {

    private notificationObservable: Observable<ApiError>;
    private notificationSubscriber: Subscriber<ApiError>;

    constructor() {
        this.notificationObservable = new Observable<ApiError>(observer => {
            this.notificationSubscriber = observer;
        });
    }

    public getNotificationObserver(): Observable<ApiError> {
        return this.notificationObservable;
    }

    public notifyError(error: ApiError) {
        if (!!this.notificationSubscriber) {
            this.notificationSubscriber.next(error);
        }
    }

}
